import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions

// components - material UI
import { Avatar, Button } from '@material-ui/core';
import Available_Funds from '../common/Available_Funds';
import Payment_Activity from '../Payments_Settings/Payment_Activity';

// icons - material UI
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CheckIcon from '@material-ui/icons/Check';
import HeadsetMicOutlinedIcon from '@material-ui/icons/HeadsetMicOutlined';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const Payment_Settings = ({ 
    auth: {
        user
    },
    handleSlideMenu, 
    history,
    goBack,
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Screen Width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const hostname = window.location.hostname;

    useEffect(() => {

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Determine mobile and tablet screen sizes
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    // Initialize Mixpanel and track settings Help page view
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Settings Payment Page View");
    }

    // Check if the code is running in production and Mixpanel event hasn't been sent yet
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        
        // Initialize Mixpanel and track the event
        handleMixpanel();

        // Set the flag to indicate that Mixpanel event has been sent
        setSentMixpanel(true);
    }

    return (
        <div className="settings">

            {/* Header */}
            <div className="settings__header">
                {isTablet && (

                    // Icon
                    <div onClick={goBack} className="profile__btnContainer">
                        <ArrowBackIcon />
                    </div>
                )}

                {/* Title */}
                <div onClick={handleSlideMenu} className="settings__headerText">
                    <h3>
                        Payments
                    </h3>
                </div>
            </div>

            {/* Main Content */}
            
            <div className="settings__body">
                <Available_Funds />
                <Payment_Activity />

                <div onClick={() => window.location = '/settings/help'} className='checkout_form_toggle'>
                    <div style={{minWidth:'100%', minHeight:'48px', alignItems:'center', display:'flex', padding:'8px 0', boxSizing:'border-box'}}>
                        <div style={{marginRight:'12px', height:'40px', alignItems:'center', justifyContent:'center', display:'flex', width:'40px', padding:'6px', borderRadius:'40px'}}>
                            <HeadsetMicOutlinedIcon />
                        </div>
                        <div style={{flexGrow: 1}}>
                            <h2 style={{fontWeight:'bold', lineHeight:'23.8px', fontSize:'18px'}}>
                                Customer Support
                            </h2>
                            <p style={{margin: '6px 0', margin: '0', fontSize: '14px'}}>
                                Have an issue? Chat with us.
                            </p>
                        </div>
                        <div style={{display:'flex', alignItems:'center'}}>
                            <div style={{fontSize:'32px', marginLeft:'32px'}}>
                                <ChevronRightIcon />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

Payment_Settings.propTypes = {
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth,
})

export default connect(mapStateToProps, null)(Payment_Settings);
